import React from "react";

const About = () => {
  return (
    <>
      <div className="about-section">
        <div className="container">
          <div className="row">
            <div data-aos="fade-right"  className="about-image-column mb-5 col-lg-6 text-center">
              <img src="./aboutw.jpg"  className="  about-image" alt="about" />
            </div>
            <div data-aos="fade-left" className="about-text-column col-lg-6">
              <div className="about-text-wrapper">
                <h2 className="section-heading">About Me 👨‍💻</h2>
                <h6 data-aos="fade-right" className="about-description">
                I am a Full Stack Web Developer with <strong>
                  {new Date().getFullYear()-2021} years</strong> of hands-on experience in designing and implementing web applications. Currently, I am pursuing my MCA from <strong>JS University</strong>, where I am deepening my knowledge of advanced programming concepts and software development practices.

                  <br />
                  <br />
                  
I thrive on solving complex problems and enjoy working on both the front-end and back-end of applications. My skill set includes proficiency in languages such as JavaScript, Python, and SQL, as well as frameworks like React and Node.js. I’m committed to delivering high-quality solutions that enhance user experience and drive business success.
                  <br />
                  <br />
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
